declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

const gaValues = () => {
  window.dataLayer = window.dataLayer || []

  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }
  }

  window.gtag("js", new Date())
  window.gtag("config", "UA-56517066-2")
}

export const reInitializeGA = () => {

  if (document.getElementById("ga-script")) return;

  const script = document.createElement("script")

  script.id = "ga-script"
  script.src = "https://www.googletagmanager.com/gtag/js?id=UA-56517066-2"
  script.setAttribute("nonce", "DhcnhD3khTMePgXw")
  script.async = true

  script.onload = () => gaValues()

  document.head.appendChild(script);
  
}

export const initializeCampaign = (params) => {
  const trackerDomain = process.env.GATSBY_TRACKER_DOMAIN ?? '';
  if (typeof window !== 'undefined') {
    if(window.document.referrer.indexOf(trackerDomain) > 0){
      const utm_id = params.get('utm_id');
      const utm_campaign = params.get('utm_campaign');
      const utm_code = params.get('utm_code');
      const utm_source = params.get('utm_source');
      const utm_medium = params.get('utm_medium');
      const utm_content = params.get('utm_content');
      const utm_name = params.get('utm_name');
      const utm_others = params.get('utm_others');

      if(utm_code){

        sessionStorage.setItem("utm_id", utm_id ?? '');
        sessionStorage.setItem("utm_campaign", utm_campaign ?? '');
        sessionStorage.setItem("utm_code", utm_code ?? '');
        sessionStorage.setItem("utm_source", utm_source ?? '');
        sessionStorage.setItem("utm_medium", utm_medium ?? '');
        sessionStorage.setItem("utm_content", utm_content ?? '');
        sessionStorage.setItem("utm_name", utm_name ?? '');
        sessionStorage.setItem("utm_others", utm_others ?? '');
        sessionStorage.setItem("has_send_oc", "0");

        const utmCodeExisting = sessionStorage.getItem('utm_code') ?? '';

        // if(utmCodeExisting != utm_code){
        //   openCount();
        // }
      }
    }
  }
}

export const getCampaignParameters = () => {
  if (typeof window !== 'undefined') {
    const utm_id = sessionStorage.getItem("utm_id") ?? '';
    const utm_campaign = sessionStorage.getItem("utm_id") ?? '';
    const utm_code = sessionStorage.getItem("utm_code") ?? '';
    const utm_source = sessionStorage.getItem("utm_source") ?? '';
    const utm_medium = sessionStorage.getItem("utm_medium") ?? '';
    const utm_content = sessionStorage.getItem("utm_content") ?? '';
    const utm_name = sessionStorage.getItem("utm_name") ?? '';
    const utm_others = sessionStorage.getItem("utm_others") ?? '';

    return {
      utm_id: utm_id,
      utm_campaign: utm_campaign,
      utm_code: utm_code,
      utm_source: utm_source,
      utm_medium: utm_medium,
      utm_content: utm_content,
      utm_name: utm_name,
      utm_others: utm_others,
    };
  }

  return {};
}

export const getCampaignLink = () => {
  const campaignParams = getCampaignParameters();

  const cleanParams = Object.fromEntries(
    Object.entries(campaignParams).filter(([_, v]) => v != null && v !== '')
  );

  const params = new URLSearchParams(cleanParams);

  return params.toString();
}

export const openCount = () => {

  if (document.getElementById("ga-script")) return;

  const trackerDomain = process.env.GATSBY_TRACKER_DOMAIN ?? '';
  const utm_code = sessionStorage.getItem("utm_code") ?? '';
  const has_send_oc = sessionStorage.getItem("has_send_oc") ?? "0";

  if(utm_code != '' && has_send_oc == "0"){ // && window.document.referrer.indexOf(trackerDomain) > 0){
    if(track('open_count')){
      sessionStorage.setItem("has_send_oc", "1");
    }
  }
}

export const track = (event) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    const params = getCampaignParameters();
    window.gtag("event", event, params);

    return true;
  }
  return false;
}